// extracted by mini-css-extract-plugin
export var description = "_9XqFk";
export var paragraph = "fgSl-";
export var root = "njOpJ";
export var title = "ct3ts";